module.exports = __webpack_public_path__ + "img/image24.33e1bfee.png";